module.exports = __webpack_public_path__ + "media/images/emblems/Courgena-55397a88cc2730fef367859635d5bbf9.png";